import Vue from 'vue'
import Vuex from 'vuex'
import { login as loginApi, getInfo } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken(),
    userInfo: null
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    LOGOUT(state) {
      state.token = null
      state.userInfo = null
    }
  },
  actions: {
    async login({ commit }, loginDTO) {
      const res = await loginApi(loginDTO)
      const token = res.data.token || res.data
      commit('SET_TOKEN', token)
      setToken(token)
      return res
    },
    async getUserInfo({ commit }) {
      const res = await getInfo()
      commit('SET_USER_INFO', res.data)
      return res.data
    },
    logout({ commit }) {
      commit('LOGOUT')
      removeToken()
    }
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo
  }
})
